module.exports = __webpack_public_path__ + "img/1538490646.32d962f1.jpg";